import SelectableContainer from "./SelectableContainer";
import {useState, useMemo} from "react";
import {Row} from "./Flexbox";

import {Popover, Box} from '@mui/material';
import {subDays, startOfYear, isValid, format} from 'date-fns';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';

const DateButtons = props => {

    const [activeContainer, setActiveContainer] = useState(props.initialType || "Hoy");
    const [anchor, setAnchor] = useState(null);
    const [selectedRange, setSelectedRange] = useState([null, null]);

    const getPeriod = (type, selectedStart, selectedEnd) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); 

        let startDate = null;
        let endDate = today; //Default value as most of the cases requiere it

        switch(type) {
            case "Hoy":
                startDate = today;
                break;
            case "Ayer":
                startDate = subDays(today, 1);
                endDate = startDate;
                break;
            case "7 días":
                startDate = subDays(today, 6);
                break;
            case "30 días":
                startDate = subDays(today, 29);
                break;
            case "90 días":
                startDate = subDays(today, 89);
                break;
            case "YTD":
                startDate = startOfYear(today);
                break;
            case "1 año":
                startDate = subDays(today, 364);
                break;
            case "2 años":
                startDate = subDays(today, 729);
                break;
            case "Elegir fechas":
                startDate = selectedStart;
                endDate = selectedEnd;
                break;
            default:
                props.onDateSelect(null); //Return null if there's not a valid period (shouldn't happen)
                break;
        }


        if(isValid(startDate) && isValid(endDate)) {
            const dateFormat = 'MM/dd/yyyy';    //Format required for the backend filters

            const formatStart = format(startDate, dateFormat);
            const formatEnd = format(endDate, dateFormat);

            let textDate;

            if(startDate.getTime() === endDate.getTime()) {
                textDate = format(startDate, 'dd MMM yyyy');    //e.g. 05 Jun 2025
            } else {
                textDate = `${format(startDate, 'dd MMM yyyy')} - ${format(endDate, 'dd MMM yyyy')}`
            }

            props.onDateSelect({
                type: type,
                startDate: formatStart,
                endDate: formatEnd,
                formattedDate: textDate
            });
        } else {
            if(type === "Elegir fechas") {
                setSelectedRange([null, null]); //Clear the invalid selection
                props.onDateSelect(null);
            }
        }
    };

    const handleClick = (text, e = null) => {
        if(activeContainer === text) {  
            if(text === "Elegir fechas") {   //Ensure the selected option remains the same after being selected again if already active
                if(Boolean(anchor)) {   //"Toggles" the calendar
                    setAnchor(null);
                } else {
                    setAnchor(e.currentTarget);
                }
            }
            return;
        }

        setActiveContainer(text);   //Set the new option as active

        if(text === "Elegir fechas") {
            setAnchor(e.currentTarget);
        } else {
            setAnchor(null);
            setSelectedRange([null, null]); //Clear the range if another option is selected
            getPeriod(text); //Get the new period
        }
    };

    const closeCalendar = () => {
        setAnchor(null);    //This only closes the Popover visually (Calendar)
    }

    const dateChange = (range) => {
        setSelectedRange(range);    //Updates the range
        const [startDate, endDate] = range;

        if(isValid(startDate) && isValid(endDate)) {
            getPeriod("Elegir fechas", startDate, endDate);
        }
    }

    const setButtonText = useMemo(() => {
        if(activeContainer === "Elegir fechas" && isValid(selectedRange[0]) && isValid(selectedRange[1])) {
            const dateFormat = 'MM/dd/yyyy'; //The format used in the Metrics view

            const formatStart = format(selectedRange[0], dateFormat);
            const formatEnd = format(selectedRange[1], dateFormat);

            return `${formatStart} - ${formatEnd}`;
        }
        return "Elegir fechas" //Default text for the button
    }, [activeContainer, selectedRange]);

    return (
        <Row style={{height: props.height, maxWidth: 'fit-content', justifyContent: 'start', alignItems: 'center', pointerEvents: props.disabled ? 'none' : 'auto', opacity: props.disabled ? 0.3 : 1}}>
            <SelectableContainer theme={props.theme} text="Hoy" active = {activeContainer === "Hoy"} onClick = {() => handleClick("Hoy")}></SelectableContainer>
            <SelectableContainer theme={props.theme} text="Ayer" active = {activeContainer === "Ayer"} onClick = {() => handleClick("Ayer")}></SelectableContainer>
            <SelectableContainer theme={props.theme} text="7 días" active = {activeContainer === "7 días"} onClick = {() => handleClick("7 días")}></SelectableContainer>
            <SelectableContainer theme={props.theme} text="30 días" active = {activeContainer === "30 días"} onClick = {() => handleClick("30 días")}></SelectableContainer>
            <SelectableContainer theme={props.theme} text="90 días" active = {activeContainer === "90 días"} onClick = {() => handleClick("90 días")}></SelectableContainer>
            <SelectableContainer theme={props.theme} text="YTD" active = {activeContainer === "YTD"} onClick = {() => handleClick("YTD")}></SelectableContainer>
            <SelectableContainer theme={props.theme} text="1 año" active = {activeContainer === "1 año"} onClick = {() => handleClick("1 año")}></SelectableContainer>
            <SelectableContainer theme={props.theme} text="2 años" active = {activeContainer === "2 años"} onClick = {() => handleClick("2 años")}></SelectableContainer>
            <SelectableContainer theme={props.theme} text={setButtonText} active = {activeContainer === "Elegir fechas"} onClick = {(e) => handleClick("Elegir fechas", e)}></SelectableContainer>
        
            <Popover open = {activeContainer === "Elegir fechas" && Boolean(anchor)} anchorEl={anchor} onClose={closeCalendar} anchorOrigin={{vertical: 'bottom', horizontal: 'left'}} transformOrigin={{vertical: 'top', horizontal: 'left'}}>
                <Box p={2}>
                    <Calendar selectRange={true} value={selectedRange} onChange={dateChange}/>
                </Box>
            </Popover>
        </Row>
    )
}

export default DateButtons;